import React from "react";
import { Collapse } from "antd";
import Button from "../shared/Button";
import Accordion from "../shared/Accordion";

const { Panel } = Collapse;
const JatickRules = ({ nextStep }) => {
  return (
    <div className="JatickRules">
      <div className="container">
        <h3>قوانین و مقررات ثبت‌نام و استفاده از جاتیک</h3>
        <p>
          این سرویس تنها رابطی بین شما و دیگر اعضاء و کاربران می باشد و هیچگونه
          کنترل و دخالتی بر انجام تعهدات میزبان، مهمان و دیگر کاربران ندارد. دقت
          کنید در هنگام پرکردن فرم و لیست، اطلاعات صحیح به طور کامل ارائه گردد.
          کاربر توافق می کند که هیچ عملکرد اشتباهی که بازتاب منفی بر سایت بگذارد
          انجام نخواهد داد. در صورتیکه در قوانین مندرج، رویه ها و سرویس‌دهی‌ها
          در آینده تغییراتی ایجاد شود، در همین صفحه منتشر و به‌روزرسانی خواهد
          شد. کاربر با استفاده از این سرویس ضمانت می کند که بالای 18 سال سن
          دارد. اگر کاربر نیابتاً از طرف شخص حقوقی این شرایط را می پذیرد یعنی
          این قدرت را دارد که آنها را پایبند به ضوابط و شرایط کند. وب سایت
          جاتیک، تابع قوانین کشور جمهوری اسلامی ایران بوده و اطلاعات وارد شده
          توسط اعضا که مغایر با این قوانین تشخیص داده شود حذف خواهد شد. همراه
          داشتن مدارک شناسایی و محرمیت در زمان مراجعه به مورد اجاره الزامی است و
          سایت جاتیک هیچگونه مسئولیتی در این مورد ندارد. سایت جاتیک برای اطلاع
          یافتن شما از مطالب جدید به شما پیامک و رایانامه ارسال می کند. شما
          بدینوسیله موافقت خودرا با دریافت اینگونه پیام‌ها اعلام می‌دارید.
          همینطور شما می‌توانید تنظیمات دریافت پیامک و رایانامه را با ارسال یک
          نامه الکترونیک به آدرس info@jatick.com تغییر دهید. استفاده از سایت شب
          فقط مخصوص کاربران ایرانی می باشد و چنانچه اتباع خارجی قصد استفاده از
          سایت را دارند می‌بایست حتماً قبل از رزرو به سایت اطلاع دهند. در غیر
          این صورت کلیه مسئولیت‌های ناشی از کنسلی رزرو بر عهده مهمان است. مهمان
          تنها یک بار امکان جابجایی تاریخ رزرو را (در صورت تایید میزبان) خواهد
          داشت. در صورت سومین کنسلی رزرو توسط مهمان (دو کنسلی رزرو قبلی طبق
          قوانین داخل آگهی رزرو شده) که مبلغ استفاده شده از اعتبار کنسلی‌های قبل
          باشد وجه پرداختی شما به منظور جلوگیری از افشای اطلاعات میزبانان و
          اقامتگاه‌های وب‌سایت شب عودت (نقدی یا اعتباری) نخواهد شد.
        </p>
        <h3>سایر قوانین وبسایت</h3>
        <div className="Accordion-box">
          <Accordion
            title="شرایط لغو رزرو"
            text="
      اً
        قبل از رزرو به سایت اطلاع دهند. در غیر این صورت کلیه مسئولیت‌های ناشی از
        کنسلی رزرو بر عهده مهمان است. مهمان تنها یک بار امکان جابجایی تاریخ رزرو
        را (در صورت تایید میزبان) خواهد داشت. در صورت سومین کنسلی رزرو توسط
        مهمان (دو کنسلی رزرو قبلی طبق قوانین داخل آگهی رزرو شده) که مبلغ استفاده
        ش"
          />
            <Accordion
            title="شرایط لغو رزرو"
            text="
      اً
        قبل از رزرو به سایت اطلاع دهند. در غیر این صورت کلیه مسئولیت‌های ناشی از
        کنسلی رزرو بر عهده مهمان است. مهمان تنها یک بار امکان جابجایی تاریخ رزرو
        را (در صورت تایید میزبان) خواهد داشت. در صورت سومین کنسلی رزرو توسط
        مهمان (دو کنسلی رزرو قبلی طبق قوانین داخل آگهی رزرو شده) که مبلغ استفاده
        ش"
          />
            <Accordion
            title="شرایط لغو رزرو"
            text="
      اً
        قبل از رزرو به سایت اطلاع دهند. در غیر این صورت کلیه مسئولیت‌های ناشی از
        کنسلی رزرو بر عهده مهمان است. مهمان تنها یک بار امکان جابجایی تاریخ رزرو
        را (در صورت تایید میزبان) خواهد داشت. در صورت سومین کنسلی رزرو توسط
        مهمان (دو کنسلی رزرو قبلی طبق قوانین داخل آگهی رزرو شده) که مبلغ استفاده
        ش"
          />
            <Accordion
            title="شرایط لغو رزرو"
            text="
      اً
        قبل از رزرو به سایت اطلاع دهند. در غیر این صورت کلیه مسئولیت‌های ناشی از
        کنسلی رزرو بر عهده مهمان است. مهمان تنها یک بار امکان جابجایی تاریخ رزرو
        را (در صورت تایید میزبان) خواهد داشت. در صورت سومین کنسلی رزرو توسط
        مهمان (دو کنسلی رزرو قبلی طبق قوانین داخل آگهی رزرو شده) که مبلغ استفاده
        ش"
          />
            <Accordion
            title="شرایط لغو رزرو"
            text="
      اً
        قبل از رزرو به سایت اطلاع دهند. در غیر این صورت کلیه مسئولیت‌های ناشی از
        کنسلی رزرو بر عهده مهمان است. مهمان تنها یک بار امکان جابجایی تاریخ رزرو
        را (در صورت تایید میزبان) خواهد داشت. در صورت سومین کنسلی رزرو توسط
        مهمان (دو کنسلی رزرو قبلی طبق قوانین داخل آگهی رزرو شده) که مبلغ استفاده
        ش"
          />
        </div>
      <div className="center">
      <Button onClick={() => nextStep(3)} varient="fifth">
          ادامه فرایند
        </Button>
      </div>
      </div>
    </div>
  );
};

export default JatickRules;
